export default __webpack_public_path__ + "static/media/fivepersonAF.61b04bea.png";